import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

interface ImportRosterEventAdapterParams {
  newStudentCount: number;
}

type ImportRosterEventData = {
  new_student_count: number;
};

export class ImportRosterEventAdapter extends EventAdapter<ImportRosterEventData> {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = function sendImportRosterEvent(
    event: ImportRosterEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.ImportRoomRoster, event);
  };

  constructor({ newStudentCount }: ImportRosterEventAdapterParams) {
    super();

    this.eventData = {
      new_student_count: newStudentCount,
    };
  }
}
